import {defineStore} from 'pinia'
import CustomStore from "devextreme/data/custom_store";
import _ from "lodash";
import axios from "axios";
import {API_BASE_URL} from "@/global-constants";
import api from "@/api";
export const useAbsenListModel  = defineStore(
    'absenListModel',
    () => {
        function convertColumnName(name, columns) {
            for (const column of columns) {
                const pattern = new RegExp(`^${column}_`);
                if (pattern.test(name)) {
                    return name.replace(pattern, `${column}.`);
                }
            }
            return name;
        }
        
        function convertArrayElements(arr, columns) {
            return _.map(arr, element => {
                if (_.isArray(element)) {
                    return convertArrayElements(element, columns);
                } else if (_.isString(element)) {
                    return convertColumnName(element, columns);
                }
                return element;
            });
        }

        function convertArrayTgl(loadArray) {
            
            _.forEach(loadArray, (item, index) => {
                if(item instanceof Date){
                     loadArray[index]= formatDateToISOString(item);
                }
                
              });

              return loadArray;
        }
        const absenListCustomStore = new CustomStore({
            key: 'absen_bulans_id',
            insert: async (values) => {
                values = convertArrayTgl(values);
               try {
                const response = await axios.post(`${API_BASE_URL}/customstore-absen-bulans/insert`, {values: values}, {
                        headers: {
                            Authorization: api.defaults.headers.common['Authorization'],
                            'Content-Type': 'application/json',
                        },
                    });
                    if (response.data) {
                        return response.data.data;
                    }
                } catch (error) {
                    console.error('Insert error:', error);
                    throw JSON.stringify(error.response.data.message, null, 2);
                }
            },
           
            update: async (key, values) => {
                values = convertArrayTgl(values);
               try {
                const response = await axios.post(`${API_BASE_URL}/customstore-absen-bulans/insert`, {values : values, id : key}, {
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });
                if (response.data) {
                    return response.data.data;
                }
                } catch (error) {
                    console.error('Insert error:', error);
                    throw JSON.stringify(error.response.data.message, null, 2);
            
                }
            },
         
            remove: async(key) => {
                try {
                    const response = await axios.delete(`${API_BASE_URL}/customstore-absen-bulans/${key}`, {
                        headers: {
                            Authorization: api.defaults.headers.common['Authorization'],
                            'Content-Type': 'application/json',
                        },
                    });
                    if (response.data) {
                        return true;
                    }
                } catch (error) {
                    console.error('Insert error:', error);
                    throw JSON.stringify(error.response.data.message, null, 2);
                }
            },
            load: async (loadOptions) => {


               
                // let loadOptions = mergedLoadOptions[0];
                // let additionalParams = mergedLoadOptions[1];
                const columns = ['absen_bulans','gajis', 'simpeg_pegawais', 'jabatans', 'cabangs', 'units', 'pegawai_statuses',  'sub_bagians', 'bagians', 'bidangs', 'sub_bidangs', 'seksis', 'status_aktifs'];
               

                let params = {};
                params.sort = "";params.filter="";
                if (loadOptions.sort) {
                    if (typeof loadOptions.sort[0].selector === 'function') {
                        loadOptions.sort[0].selector= loadOptions.sort[0].selector.context.column.dataField;
                    }
                    params.sort = JSON.stringify(convertArrayElements(loadOptions.sort, columns));
                }
               
                
                if (loadOptions.filter) {
                    loadOptions.filter = processLoadArray(loadOptions.filter); //benerin format tanggal
                    let temp = [];
                   
                    temp = convertArrayElements(loadOptions.filter, columns)
                    params.filter = JSON.stringify(temp);
                   
                }


               // ================FILTER DEFAULT --> filter pegawai yang aktif
                loadOptions.filterDefault = [];
                if(params.filter === ""){
                    // loadOptions.filterDefault.push(['simpeg_pegawais.status_aktif_id', '=', '1']);
                }
                // if (additionalParams) {
                //     var coba = convertArrayElements(additionalParams, columns);
                    
                //     loadOptions.filterDefault.push(coba);
                // }
                
                
                params.filterDefault = JSON.stringify(loadOptions.filterDefault );

                //================SORT DEFAULT --> sort jabatan_id asc, nik
                loadOptions.sortDefault = [];
                // if(!params.sort.includes("jabatans.nama")){
                //     loadOptions.sortDefault.push({"selector":"jabatans.id","desc":false});
                // }
                // if(!params.sort.includes("nik")){
                //     loadOptions.sortDefault.push({"selector":"nik","desc":false});
                // }
                
                // const hasOnlyAbsenBulanId = loadOptions.sort.length === 1 && _.get(loadOptions.sort[0], 'selector') === 'absen_bulans_id';

                const hasOnlyTableId = loadOptions.sort && loadOptions.sort.length === 1 && _.get(loadOptions.sort[0], 'selector') === 'absen_bulans_id';

                if(params.sort === "" || hasOnlyTableId){
                    loadOptions.sortDefault.push({"selector":"periode_absen","desc":true});
                    loadOptions.sortDefault.push({"selector":"riwayat_pekerjaans.jabatan_id","desc":false});
                    loadOptions.sortDefault.push({"selector":"simpeg_pegawais.nik","desc":false});
                    loadOptions.sortDefault.push({"selector":"riwayat_pekerjaans.pegawai_status_id","desc":false});
                    loadOptions.sortDefault.push({"selector":"simpeg_pegawais.tgl_mulai_bekerja","desc":false});
                    loadOptions.sortDefault.push({"selector":"simpeg_pegawais.nama","desc":false});
                    

                    params.sort = "";
                    
                    // loadOptions.sortDefault.push({"selector":"riwayat_pekerjaans.tgl_mulai_bekerja","desc":false});
                }
                //else{
                    // console.log("debug masuk sort ada", loadOptions.sort)
                    // if(!_.some(loadOptions.sort, { selector: 'simpeg_pegawais_nik' })){
                    //     //tidak ada sorting nik, maka automatically add sort by nik
                    //     loadOptions.sortDefault.push({"selector":"simpeg_pegawais.nik","desc":false});
                    // }
    
                    // if(!_.some(loadOptions.sort, { selector: 'tgl_mulai_bekerja'})){
                    //     //tidak ada sorting tgl_mulai_bekerja, maka automatically add sort by tgl_mulai_bekerja
                    //     loadOptions.sortDefault.push({"selector":"riwayat_pekerjaans.tgl_mulai_bekerja","desc":false});
                    // }
                //}
               
                    
                params.sortDefault = JSON.stringify(loadOptions.sortDefault );

                ////////////////////////////////////

                if (loadOptions.skip) {
                    params.skip = loadOptions.skip;
                }

                if (loadOptions.take) {
                    params.take = loadOptions.take;
                }

               

                const response = await axios.get(`${API_BASE_URL}/customstore-absen-bulans`, {
                    params: params,
                    headers: {
                        Authorization: api.defaults.headers.common['Authorization'],
                        'Content-Type': 'application/json',
                    },
                });

                
        
          
              
                if (response.data) {
                    return {
                        data: response.data.data,
                        totalCount: response.data.totalCount,
                        summary: response.data.summary,
               
                    };
                }

                throw 'Data loading error';
            },
        });


          
       

        function processLoadArray(loadArray) {
            return _.map(loadArray, item => {
                if (_.isArray(item)) {
                    // Check if 'periode_absen' is present in the sub-array
                    if (_.includes(item, 'tgl_mulai_bekerja') || _.includes(item, 'tgl_lahir') || _.includes(item, 'pensiun_tgl')) {
                        // Map through the sub-array to find and convert Date objects
                        return _.map(item, subItem => {
                            return subItem instanceof Date ? formatDateToISOString(subItem) : subItem;
                        });
                    } else {
                        // Recursively process nested arrays
                        return processLoadArray(item);
                    }
                }
                return item;
            });
        }

        




        function formatDateToISOString(date) {
            function pad(n) { return n < 10 ? '0' + n : n }
            return date.getFullYear() + '-' +
                pad(date.getMonth() + 1) + '-' +
                pad(date.getDate());
        }


        return {
            absenListCustomStore,
           
        }
    });